import { useEffect, useState } from "react";
import AgentsTab from "../components/agents/AgentsTab";
import { assignTask, getAgentDetail, getAgents, getTasksList, updateUserRequest } from "../assets/constants/global_apis";
import SearchMenu from "../components/SearchMenu";
import AlertPopup, { triggerAlert } from "../components/AlertMessage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faServer } from "@fortawesome/free-solid-svg-icons";

export default function Agents() {
  const [initialAgentsList, setInitialAgentsList] = useState([]);
  const [agentsList, setAgentsList] = useState([]);
  const [selectedAgentIndx, setSelectedAgentIndx] = useState(-1);
  const [selectedAgent, setSelectedAgent] = useState({});
  const [selectedAgentDetail, setSelectedAgentDetail] = useState({});
  const [setectedAgentJobDetail, setSelectedAgentJobDetail] = useState({});
  const [showAgentView, setShowAgentView] = useState(false);
  const [tasksList, setTasksList] = useState([])
  const [userRequests, setUserRequest] = useState({})
  const [selectedTask, setSelectedTask] = useState({});
  // const getCollections = () => {
  //   get_all_collections().then(data => {
  //     setCollectionsList(data);
  //     console.log(data);
  //   })
  //     .catch(error => console.log(error));
  // }

  // const getDataSets = () => {
  //   get_all_collections().then(data => {
  //     setCollectionsList(data);
  //     console.log(data);
  //   })
  //     .catch(error => console.log(error));
  // }

  const geAllagentsList = () => {
    getAgents()
      .then(data => {
        setInitialAgentsList(data);
        if (data && data.length > 0 && !data[0]?.message) {
          setAgentsList(data.map(agent => ({
            label: agent.agent_id,
            id: agent.agent_id,
            last_timestamp: agent.last_timestamp
          })))
          if (selectedAgentIndx >= 0 && (Object.keys(selectedAgent)).length > 0) {
            data.map((agent, index) => {
              if (agent.agent_id == selectedAgent.label) {
                setSelectedAgent({
                  label: agent.agent_id,
                  id: agent.agent_id
                });
                setSelectedAgentIndx(index);
              }
            }
            )
          } else {
            setSelectedAgent({})
          }
        }else{
          setAgentsList([])
          setSelectedAgent({})
          setSelectedAgentIndx(-1)
          setSelectedAgentDetail({})
          setShowAgentView(false)
        }
      })
  }
  function convertUTCToLocalTime(utcDateString) {
    const utcDate = new Date(utcDateString);
    const localDate = new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60000);
    return localDate.toISOString().split('T').join(' ').slice(0, 19);
  }
  useEffect(() => {
    let userReqs = {};
    if (tasksList && tasksList.length > 0) {
      for (let i = 0; i < tasksList.length; i++) {
        userReqs[tasksList.task_name] = ''
      }
      userReqs[setectedAgentJobDetail.current_job_name] = setectedAgentJobDetail?.current_job_status == 'IN_PROGRESS' ? 'PAUSE' : setectedAgentJobDetail?.current_job_status == 'COMPLETED' ? 'COMPLETED' : setectedAgentJobDetail?.current_job_status == 'PAUSED' ? 'DO' : setectedAgentJobDetail?.current_job_status == 'FAILED' || setectedAgentJobDetail?.current_job_status == 'CANCELLED' ? 'CANCEL' : 'PAUSE';
      setUserRequest(userReqs)
    }
  }, [setectedAgentJobDetail])

  const getTasks = (agentId) => {
    getTasksList(agentId)
      .then(data => {
        setTasksList(data);
      })
  }


  const handleRefreshAgents = () => {
    setInitialAgentsList([])
    setAgentsList([])
    geAllagentsList()
  }

  const filterAgents = (e) => {
    if (e.target.value !== "") {
      let filteredAgents = initialAgentsList.filter((agent) => agent.agent_id.toLowerCase().includes(e.target.value.toLowerCase()));
      if (filteredAgents && filteredAgents.length > 0 && !filteredAgents[0]?.message) {
        setAgentsList(filteredAgents.map(agent => ({
          label: agent.agent_id,
          id: agent.agent_id,
          last_timestamp: agent.last_timestamp
        })));
      }
    } else {
      if (initialAgentsList && initialAgentsList.length > 0 && !initialAgentsList[0]?.message) {
        setAgentsList(initialAgentsList.map(agent => ({
          label: agent.agent_id,
          id: agent.agent_id,
          last_timestamp: agent.last_timestamp
        })))
      }
    }
  }
  useEffect(() => {
    geAllagentsList();
    const intervalCall = setInterval(() => {
      const jbDtl = sessionStorage.getItem('selectedAgentJobDetails');
      const sltedAgnt = sessionStorage.getItem('selectedAgent');
      let selectedAgentJbDtl = {}, selectedAgentDtl = {};
      if (jbDtl && jbDtl != 'undefined' && jbDtl != undefined && sltedAgnt && sltedAgnt != 'undefined' && sltedAgnt != undefined) {
        selectedAgentJbDtl = JSON.parse(jbDtl);
        selectedAgentDtl = JSON.parse(sltedAgnt);
      }
      if (!selectedAgentJbDtl && Object.keys(selectedAgentJbDtl).length == 0 && !selectedAgentDtl && Object.keys(selectedAgentDtl).length == 0) {
        geAllagentsList();
      } else {
        getAgents()
          .then(data => {
            setInitialAgentsList(data);
            if (data && data.length > 0 && !data[0]?.message) {
              setAgentsList(data.map(agent => ({
                label: agent.agent_id,
                id: agent.agent_id,
                last_timestamp: agent.last_timestamp
              })))
              if (selectedAgentDtl && selectedAgentDtl != 'undefined' && selectedAgentDtl != undefined && Object.keys(selectedAgentDtl).length > 0) {
                data.map((agent, index) => {
                  if (agent.agent_id == selectedAgentDtl.agent_id) {
                    getTasks(agent.agent_id)
                    getSelectedAgentJobDetail(selectedAgentJbDtl.agent_unique_id)
                    setSelectedAgent({
                      label: agent.agent_id,
                      id: agent.agent_id
                    });
                    const lastTimestamp = agent.last_timestamp
                      ? convertUTCToLocalTime(agent.last_timestamp)
                      : null;
                    let cpy_agent = {
                      ...agent,
                      last_timestamp: lastTimestamp
                    }
                    setSelectedAgentDetail(cpy_agent)
                    setSelectedAgentIndx(index);
                    handleAgentClick({
                      label: agent.agent_id,
                      id: agent.agent_id
                    }, index, true);
                  }
                }
                )
              } else {
                setSelectedAgent({})
              }
            }else{
              setAgentsList([])
              setSelectedAgent({})
              setSelectedAgentIndx(-1)
              setSelectedAgentDetail({})
          setShowAgentView(false)
            }
          })
      }
    }, 30000);
    return () => {
      clearInterval(intervalCall);
    };
  }, [])


  const getSelectedAgentJobDetail = (agent_id) => {
    getAgentDetail(agent_id).then((data) => {
      setSelectedAgentJobDetail(data);
      sessionStorage.setItem('selectedAgentJobDetails', JSON.stringify(data));
    }).catch(error => {
      triggerAlert('error', error.message);
    })
  }

  const handleUserRequest = (user_request, job_id, task, tempStatus) => {
    updateUserRequest(job_id, { 'user_request': user_request == 'CANCEL' ? 'CANCEL' : user_request == 'PAUSE' ? 'PAUSE' : user_request == 'DO' ? 'DO' : 'DO' })
      .then(() => {
        triggerAlert('success', 'User request updated successfully');
        sessionStorage.setItem('job_status_changed', JSON.stringify({
          agent_id: selectedAgent.label,
          task_name: task.task_name,
          status: tempStatus,
          assigned_time: new Date().toISOString() // Store as ISO string for consistency
        }))
        getSelectedAgentJobDetail(selectedAgent.label);
      }).catch(error => {
        triggerAlert('error', error.message);
      });
  }




  const handleAgentClick = (element, index, ignoreAgentDetail = false) => {
    setSelectedAgentIndx(index)
    setSelectedAgent(element);
    let agent = initialAgentsList.filter(agent => agent?.agent_id == element?.label || agent?.agent_id == element?.agent_id);
    if (agent.length > 0) {
      const lastTimestamp = agent[0].last_timestamp
        ? convertUTCToLocalTime(agent[0].last_timestamp)
        : null;
      let cpy_agent = {
        ...agent[0],
        last_timestamp: lastTimestamp
      }
      !ignoreAgentDetail && setSelectedAgentDetail(cpy_agent);
      sessionStorage.setItem('selectedAgent', JSON.stringify(agent[0]));
      !ignoreAgentDetail && getTasks(agent[0]?.agent_id)
      !ignoreAgentDetail && getSelectedAgentJobDetail(agent[0]?.agent_id)
    }
    setShowAgentView(true)
  }

  const handleTaskAssign = (task_name, formData) => {
    let req_args = {};
    for (let key in formData) {
      if (key != 'user_request') {
        if (selectedTask?.task_args[key].type == 'collectionId' || selectedTask?.task_args[key].type == 'modelId' || selectedTask?.task_args[key].type == 'datasetId' || selectedTask?.task_args[key].type == 'backendId') {
          req_args[key] = formData[key].id;
        } else {
          req_args[key] = formData[key];
        }
      }
    }
    assignTask(selectedAgent.label, {
      task_name: task_name,
      args: req_args,
      user_request: "DO"
    }).then((data) => {
      triggerAlert('success', 'Job created successfully');
      sessionStorage.setItem('task_job_assigned', JSON.stringify({
        agent_id: selectedAgent.label,
        task_name: task_name,
        assigned_time: new Date().toISOString() // Store as ISO string for consistency
      }));
      getSelectedAgentJobDetail(selectedAgent.label);
    }).catch((error) => {
      triggerAlert('error', error.message)
    });
  }
  const handleAgentStatus = (status, task) => {
    console.log('Agent status', status);
    if (userRequests[task.task_name] != 'CANCEL') {
      let userReqs = JSON.parse(JSON.stringify(userRequests));
      userReqs[task.task_name] = status == 'PAUSE' ? 'DO' : status == 'DO' ? 'PAUSE' : 'CANCEL';
      setUserRequest(userReqs)
      handleUserRequest(status, setectedAgentJobDetail.current_job_id, task, userReqs[task.task_name]);
    } else {
      triggerAlert('error', 'Job already cancelled');
    }
  }


  return (
    <div className="container-fluid g-2 agens-tab-contaienr">
      <AlertPopup />
      <div className="row g-2">
        <SearchMenu
          filterFunction={filterAgents}
          ElementList={agentsList}
          handleOnClickItem={handleAgentClick}
          selectedItem={selectedAgent}
          title='Agent'
          buttonAction='Refresh'
          isIconRequired={false}
          customMenuIcon={<FontAwesomeIcon icon={faServer} className="cpu-menu-icon" />}
          isActiveRequired={true}
          isDeleteNotRequired={true}
          hideWord={false}
          customSelectedStyle={""}
          handleRefreshAgents={handleRefreshAgents}
        />

        <div className="col-md-9">
          {showAgentView &&
            <AgentsTab
              selectedagentId={selectedAgent.id}
              handleRefreshAgents={handleRefreshAgents}
              selectedAgentDetail={selectedAgentDetail}
              tasksList={tasksList}
              setectedAgentJobDetail={setectedAgentJobDetail}
              setTasksList={setTasksList}
              handleUserRequest={handleUserRequest}
              handleTaskAssign={handleTaskAssign}
              handleAgentStatus={handleAgentStatus}
              userRequests={userRequests}
              selectedTask={selectedTask}
              setSelectedTask={setSelectedTask}
            />}

        </div>
      </div>
    </div>
  );
};
